<template>

	<div :key="componentKey">
		<nav class="bg-white relative shadow z-10">

			<app-header :auth="$attrs.auth"/>

			<Head title="Team Management" />

			<header class="lg:px-8 max-w-7xl mx-auto px-4 py-6 sm:px-6 border-t border-gray-200">

				<!-- Start icon listings -->
				<div class="gap-6 grid grid-cols-5 lg:gap-x-8 sm:gap-y-8">


<!--					<div v-for="collection in props.collections" :key="collection.id">-->
<!--						<Link class="group relative bg-white rounded-lg shadow flex items-center h-[50px] border border-gray-200"-->
<!--							  :class="[activeCollection.id === collection.id ? 'ring-2 ring-blue-400 ring-opacity-40' : 'hover:ring-2 hover:ring-blue-400 hover:ring-opacity-40']"-->
<!--							  :href="collection.short_name">-->
<!--							<div class="py-3 px-2 flex items-center"><p class="text-sm font-medium text-gray-900"> {{ collection.name }}&nbsp;&nbsp;</p><p class="text-xs font-medium text-gray-500"> {{ collection.slides_count }} slide{{ collection.slides_count === 1 ? '' : 's' }}</p></div>-->
<!--						</Link>-->
<!--					</div>-->


					<Link v-for="team in props.teams" :key="team.id" @click="changeTeam(team.id)" :only="['attrs']"
						  data-heap="change-team"
						class="group relative bg-white rounded-lg shadow overflow-hidden flex items-center border border-gray-200 hover:ring-2 hover:ring-blue-400 hover:ring-opacity-40"
						:class="[team.isUserPrimary ? 'ring-2 ring-blue-400 ring-opacity-40' : 'hover:ring-2 hover:ring-blue-400 hover:ring-opacity-40']"

					>
						<span v-if="team.type !== 'personal'" class="flex">
							<div class="pl-2">
								<img :src="'https://www.google.com/s2/favicons?domain=' + team.domain + '&sz=256'" class="h-6 m-2" >
							</div>
							<div class="block">
								<div class=" px-2"><p class="text-sm font-semibold text-gray-900"> {{ team.name }} </p></div>
								<div class=" px-2"><p class="text-xs font-medium text-gray-700"> {{ team.domain }} </p></div>
							</div>
						</span>

						<div v-else class="flex">
							<div class="pl-2">
								<svg class="h-6 m-2" stroke-width="1.5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
									<path d="M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M4.271 18.3457C4.271 18.3457 6.50002 15.5 12 15.5C17.5 15.5 19.7291 18.3457 19.7291 18.3457" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
									<path d="M12 12C13.6569 12 15 10.6569 15 9C15 7.34315 13.6569 6 12 6C10.3431 6 9 7.34315 9 9C9 10.6569 10.3431 12 12 12Z" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/>
								</svg>
							</div>
							<div class="py-3 px-2"><p class="text-sm font-medium text-gray-900"> Personal Account </p></div>
						</div>

					</Link>


					<!-- Create new team -->
					<div class="group relative bg-white rounded-lg shadow overflow-hidden flex items-center border "
						 :class="[newTeamDuplicateWarning ? 'border-red-700' : 'border-gray-200 hover:ring-2 hover:ring-blue-400 hover:ring-opacity-40']">

						<div class="flex items-center h-[50px] px-2">
							<input type="text" name="title" id="labelname"
								   class="block w-full border-0 text-sm font-medium placeholder-gray-500 focus:ring-0"
								   placeholder="Create new team..."
								   v-model="form.newTeamName"
								   @keydown.space.stop
								   @keydown.enter.prevent="addTeam()"
								   data-heap="create-new-team-input"
							/>
						</div>
						<button v-if="form.newTeamName.length > 0" @click="addTeam()" class="border border-gray-300 hover:bg-gray-100 hover:cursor-pointer mr-3 p-2 rounded shadow">
							<svg class="h-3 fill-gray-600" viewBox="-148.269 -27.249 512 377.175" xmlns="http://www.w3.org/2000/svg"><path d="M310.1313-27.249v184.975h-355.2l96.1-98.4-37.8-38.6-161.5 164.6 161.5 164.6 37.8-38.6-96.1-98.4h408.8V-27.249z"/></svg>
						</button>
						<div v-if="newTeamDuplicateWarning" class="absolute inset-0 bg-red-50 font-bold text-red-600 text-sm">
							<div class="flex h-full items-center justify-center">Already exists!</div>
						</div>
					</div>



				</div>
			</header>
		</nav>

		<main class="">
			<div class="max-w-3xl mx-auto py-12 px-4 sm:px-6 lg:px-8">
				<div class="flex flex-wrap justify-center">
					<div class="w-full">

						<personal-team-card v-if="isPersonalTeam"></personal-team-card>

						<team-header-card v-if="!isPersonalTeam" :auth="$attrs.auth"></team-header-card>
						<billing-redirect :auth="$attrs.auth" :onGracePeriod="onGracePeriod" :subscriptionEndsAt="subscriptionEndsAt"></billing-redirect>

						<user-table v-if="!isPersonalTeam" :users="currentTeamUsers" :current-user="$attrs.auth.user" :base-url="props.baseUrl"></user-table>


					</div>
				</div>
			</div>
		</main>

		<general-notification :open=GeneralNotificationOpen @close="GeneralNotificationOpen = false"
		:title="Object.keys($attrs.errors)[0]"
		:description="$attrs.errors[Object.keys($attrs.errors)[0]]"></general-notification>

	</div>

</template>




<script setup>
import {Head, Link, useForm} from '@inertiajs/vue3';
import AppHeader from "@/Layouts/AppHeader";
import {computed, ref, watch} from "vue";
import UserTable from "@/Components/TeamManagement/UserTable";
import BillingRedirect from "@/Components/TeamManagement/BillingRedirect.vue";
import TeamHeaderCard from "@/Components/TeamManagement/TeamHeaderCard.vue";
import GeneralNotification from "@/Components/GeneralNotification.vue";
import PersonalTeamCard from "@/Components/TeamManagement/PersonalTeamCard.vue";
import { useAttrs } from 'vue'

const attrs = useAttrs()

const newTeamDuplicateWarning = ref(false);

const GeneralNotificationOpen = ref(false);

const watchErrors = () => {
	watch(
		() => attrs.errors,
		(newErrors) => {
			// Check if there is at least one array in errors
			GeneralNotificationOpen.value = Object.keys(newErrors).length > 0;
		},
		{ immediate: true } // Trigger the watcher immediately when the component is mounted
	);
};
watchErrors();


const isPersonalTeam = computed(() => attrs.auth.user.current_team?.type === 'personal');

const componentKey = ref(0);

// const isPersonalTeam = ref(attrs.auth.user.current_team.type === 'personal');

const props = defineProps({
	teams: {type: Object},
	currentTeamUsers: {type: Object},
	baseUrl: {type: String},
	onGracePeriod: {type: Boolean},
	subscriptionEndsAt: {type: String}
});

const form = useForm({
	newTeamName: '',
});

const formChangeTeam = useForm({
	selectedTeam: null
})

function addTeam() {

	if(!form.processing) {
		form.post('/team-management/create', {
			onError: () => {
				newTeamDuplicateWarning.value = true
				form.newTeamName = '';
				setTimeout(() => newTeamDuplicateWarning.value = false, 3000)
			},
			onSuccess: () => {
				componentKey.value += 1;
			}
		});
	}
}

function changeTeam($teamID) {



	formChangeTeam.selectedTeam = $teamID;

	if(!formChangeTeam.processing) {
		formChangeTeam
			// .transform does not work - https://github.com/inertiajs/inertia/discussions/1359
			// .transform((data) => ({
			// 	...data,
			// 	selectedTeam: $teamID,
			// }))
			.post('/team-management/change-current-team', {
			onSuccess: () => {
				componentKey.value += 1;
				// partial reload?
			}
		})
	}
}



</script>